import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCompanyConfig } from "../../api";
import KancelariaLogo from "../../assets/kancelaria-logo.svg";
import ContactsPage from "./ContactsPage";
import ImportPage from "./ImportPage";
import TemplatesPage from "./TemplatesPage";
import SendPage from "./SendPage";
import AttachmentsPage from "./AttachmentsPage";
import LetterheadsPage from "./LetterheadsPage";
import SmtpSettingsPage from "./SmtpSettingsPage";
import "./Mailer.css";

const TABS = [
  { id: "contacts", label: "კონტაქტები", icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" },
  { id: "import", label: "იმპორტი", icon: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" },
  { id: "templates", label: "შაბლონები", icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" },
  { id: "attachments", label: "ფაილები", icon: "M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" },
  { id: "letterheads", label: "ტიტულარები", icon: "M4 6h16M4 12h16M4 18h7" },
  { id: "send", label: "გაგზავნა", icon: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" },
  { id: "settings", label: "პარამეტრები", icon: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z" },
];

export default function MailerDashboard() {
  const [activeTab, setActiveTab] = useState("contacts");
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const departmentData = JSON.parse(localStorage.getItem("department")) || {};
  const company = getCompanyConfig();

  function handleLogout() {
    localStorage.clear();
    navigate("/");
  }

  function renderContent() {
    switch (activeTab) {
      case "contacts": return <ContactsPage key="contacts" />;
      case "import": return <ImportPage key="import" />;
      case "templates": return <TemplatesPage key="templates" />;
      case "attachments": return <AttachmentsPage key="attachments" />;
      case "letterheads": return <LetterheadsPage key="letterheads" />;
      case "send": return <SendPage key="send" />;
      case "settings": return <SmtpSettingsPage key="settings" />;
      default: return <ContactsPage key="contacts" />;
    }
  }

  return (
    <div className="mailer-layout">
      {/* Header */}
      <div className="credo-header">
        <div className="header-left">
          <div className="header-logo-wrap">
            {company?.logo_url ? (
              <img src={company.logo_url} className="header-logo" alt={company.name} />
            ) : (
              <img src={KancelariaLogo} className="header-logo" alt="AI კანცელარია" />
            )}
          </div>
          <div className="header-divider" />
          <div className="header-text">
            <span className="header-title">
              {company?.name ? `${company.name} — მეილერი` : "ელ. ფოსტის მართვა"}
            </span>
          </div>
        </div>
        <div className="header-right">
          <div className="header-user">
            <div className="header-user-avatar">
              {(departmentData.department_name || "?")[0]}
            </div>
            <span className="header-dept">{departmentData.department_name || ""}</span>
          </div>
          <button className="logout-btn" onClick={handleLogout}>გასვლა</button>
        </div>
      </div>

      {/* Sidebar + Content */}
      <div className="mailer-body">
        <nav className={`mailer-sidebar ${collapsed ? "collapsed" : ""}`}>
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`sidebar-item ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
              title={tab.label}
            >
              <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d={tab.icon} />
              </svg>
              <span className="sidebar-label">{tab.label}</span>
            </button>
          ))}
          <div style={{flex: 1}} />
          <button
            className="sidebar-toggle"
            onClick={() => setCollapsed(c => !c)}
            title={collapsed ? "გაშლა" : "შეკუმშვა"}
          >
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d={collapsed ? "M9 5l7 7-7 7" : "M15 19l-7-7 7-7"} />
            </svg>
          </button>
        </nav>
        <main className="mailer-content">
          {renderContent()}
        </main>
      </div>
    </div>
  );
}
